import { Alert, Box, Flex, Skeleton } from "@chakra-ui/react";
import { useMemo } from "react";
import { PageChangeButtons } from "./PageChangeButtons";

type Props = {
  children: React.ReactNode;
  totalItems: number;
  pageSize: number;
  index: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  isLoading?: boolean;
  loadingComponent?: React.ReactNode;
  headerComponent?: React.ReactNode;
  loadingSize?: number;
  messageNoResult?: string;
  hasTopPagination?: boolean;
  hasBottomPagination?: boolean;
  onPageChange: (page: number) => void;
};

export const Pagination = ({
  children,
  totalItems = 0,
  pageSize = 0,
  index = 0,
  hasPreviousPage = false,
  hasNextPage = false,
  onPageChange,
  isLoading = false,
  loadingSize = 30,
  loadingComponent = null,
  headerComponent = null,
  hasTopPagination = true,
  hasBottomPagination = true,
  messageNoResult = "Não foi encontrado nenhum registro."
}: Props) => {
  const content = useMemo(() => {
    if (isLoading) {
      return (
        <>
          {Array.from(Array(pageSize).keys()).map((x) => (
            <Skeleton mb="2" key={String(x)} height={`${loadingSize}px`}>
              {loadingComponent}
            </Skeleton>
          ))}
        </>
      );
    }

    if (!isLoading && totalItems == 0) {
      return (
        <Box>
          <Alert mt="2" status="info">
            {messageNoResult}
          </Alert>
        </Box>
      );
    }
    return children;
  }, [
    children,
    isLoading,
    totalItems,    
    messageNoResult,
    loadingSize,
    loadingComponent,
    pageSize
  ]);

  return (
    <Box>
      <Flex
        justifyContent="space-between"
        direction={{ base: "column", md: "row" }}
        mb={2}
      >
        <Box overflowY="auto">
          <Flex flex={1}>
            {headerComponent}
          </Flex>
        </Box>
        {hasTopPagination && (
          <PageChangeButtons
            totalItems={totalItems}
            index={index}
            pageSize={pageSize}
            onPageChange={onPageChange}
            hasPreviousPage={hasPreviousPage}
            hasNextPage={hasNextPage}
          />
        )}
      </Flex>
      {content}
      <Flex justifyContent="flex-end" mt={2}>
        {hasBottomPagination && (
          <PageChangeButtons
            totalItems={totalItems}
            index={index}
            pageSize={pageSize}
            onPageChange={onPageChange}
            hasPreviousPage={hasPreviousPage}
            hasNextPage={hasNextPage}
          />
        )}
      </Flex>
    </Box>
  );
};
